import styled from "styled-components";

const LogoStyled = styled.div`
    position: fixed;
    padding: 32px 7px;
    z-index: 300;
`

export default LogoStyled;